var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Menu navigation icon"),React.createElement("path",{"d":"M24.6 15.4H7.7c-2.3 0-5 .3-5.1-3C2.4 9.1 5 9 7.4 9h34.9c2.2 0 4.5.1 4.6 3 .1 3.3-2.4 3.3-4.8 3.3-5.8.1-11.7.1-17.5.1zm0 12.8H7.7c-2.3 0-5 .3-5.1-3-.1-3.3 2.4-3.3 4.8-3.3h34.9c2.2 0 4.5.1 4.6 3 .1 3.3-2.4 3.3-4.8 3.3H24.6zm.6 12.8H8.3c-2.3 0-5 .3-5.1-3-.1-3.3 2.4-3.3 4.8-3.3h34.9c2.2 0 4.5.1 4.6 3 .1 3.3-2.4 3.3-4.8 3.3H25.2z","key":1})]);
}

Hamburger.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
